import React, { useEffect } from 'react';
import Papa from 'papaparse';
// import csvFile from '../../assets/apiUsersDataNew.csv'

const CsvDownloader = () => {
  const downloadCsv = async () => {
    // Path to the local CSV file within the public folder
    const csvFilePath = '/apiUsersDataNew.csv';

    try {
      // Read the CSV file
      const response = await fetch(process.env.PUBLIC_URL + csvFilePath);
      const csvData = await response.text();

      // Convert CSV data to array
      const dataArray = Papa.parse(csvData).data;

      // Convert array back to CSV string
      const csv = Papa.unparse(dataArray);

      // Create a Blob and initiate download
      const blob = new Blob([csv], { type: 'text/csv' });
      const link = document.createElement('a');

      link.href = URL.createObjectURL(blob);
      link.download = 'downloaded.csv';

      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);
    } catch (error) {
      console.error('Error reading CSV file:', error);
    }
  };

  // useEffect(() => {
  //   // Fetch data on component mount (optional)
  //   // downloadCsv();
  // }, []);

  return (
    <div>
      <button onClick={downloadCsv}>Download CSV</button>
    </div>
  );
};

export default CsvDownloader;
